// extracted by mini-css-extract-plugin
export default {"container":"DgC48","logo":"q7yI8","recenter":"C4Nm4","label":"yJ56o"};